const styles = {
  sidebarMenuHeader: {
    height: '60px',
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.08)',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px',
    borderBottom: 'solid 2px rgba(0, 0, 0, 0.08)',
  },

  text: {
    fontFamily: 'FuturaTodayBold',
    fontSize: '12px',
    color: '#333333',
  },

  exit: {
    color: ' #dd9933',
    flex: 1,
    weight: 600,
    textAlign: 'right',
  },
};
export default styles;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarHeader.styles.js